<template>
  <div class="model-group-table-box">
    <div class="common-table-box">
      <el-table
        highlight-selection-row
        class="publish-table"
        ref="modelGroupTable"
        :header-row-class-name="customHeaders"
        :data="dataList"
        height="100%"
        @select="selectChange"
        @select-all="selectAll"
        @cell-click="handleClick">
        <el-table-column
          type="selection"
          width="60"></el-table-column>
        <el-table-column
          label="序号"
          width="55"
          type="index"
          :index="indexMethod">
        </el-table-column>
        <el-table-column
          label="名称/大小"
          width="340">
          <template v-slot="{ row }">
            <div :class="`icon-column ${isDisable(row) ? 'disabled' : ''}`">
              <div class="icon-column-center">
                <icon-svg
                  v-if="getIcon(row)?.icon"
                  :class="`${getIcon(row).className}`"
                  :title="getIcon(row).title"
                  :icon-class="getIcon(row).icon" />
              </div>
              <div class="content-box text-overflow">
                <div
                  class="name text-overflow"
                  v-permission="'Project.Single.Metadata.Bim.Preview'"
                  @click="modelView(row)">
                  <span :title="row.nodeName">{{ row.nodeName }}</span>
                </div>
                <div
                  class="details"
                  v-if="row.nodeType === 2">
                  <span>
                    大小：{{
                      `${formatFileSize(row.length).fileSize}${
                        formatFileSize(row.length).unit
                      }`
                    }}
                  </span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="创建日期/转换时间"
          width="250">
          <template v-slot="{ row }">
            <div>
              {{
                row.lastModificationTime
                  ? formatTime(row.lastModificationTime)
                  : formatTime(row.creationTime)
              }}
            </div>
            <div
              style="font-size: 12px"
              v-if="row.nodeType === 2">
              {{ formatSecond(row.convertDuration) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="版本号"
          min-width="90">
          <template slot="header">
            <span>版本号</span>
            <icon-svg
              class="version-icon"
              title="版本号代表文件转换成功的次数"
              icon-class="ic-banbenhao" />
          </template>
          <template slot-scope="scope">
            <span v-if="scope.row.successVersion">{{
              scope.row.successVersion
            }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          label="转换状态"
          width="200">
          <template v-slot="{ row }">
            <div v-if="row.nodeType === 1 || row.status === 6">--</div>
            <div
              v-else-if="row.status === 0"
              class="status-text">
              <div class="circle bg-color1"></div>
              <span class="color1">未转换</span>
            </div>
            <div
              v-else-if="row.status === 1"
              class="status-text">
              <div class="circle bg-color2"></div>
              <span class="color2">排队中</span>
            </div>
            <div
              v-else-if="row.status === 4"
              class="status-text">
              <div class="circle bg-color3"></div>
              <span class="color3">转换失败</span>
            </div>
            <div
              v-else-if="row.status === 5"
              class="status-text">
              <div class="circle bg-color4"></div>
              <span class="color4">已转换</span>
            </div>
            <div
              v-else-if="row.status === 2"
              class="common-progress-box">
              <el-progress
                :show-text="false"
                :percentage="row.rate"
                key="progerss" />
              <div
                class="custom-text"
                key="tipText">
                <div class="text">{{ `${row.rate ? row.rate : 0}%` }}</div>
                <div class="progress-name-box">
                  <div
                    class="msg-box text-overflow"
                    :title="row.rateMsg">
                    {{ row.rateMsg ? row.rateMsg : '' }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="坐标系"
          min-width="120px">
          <template v-slot="{ row }">
            <span
              class="text-overflow"
              :title="getCoordinate(row)">
              {{ getCoordinate(row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="240"
          v-if="isOperateVisible() && !isDemoProject()">
          <template v-slot="{ row }">
            <div
              class="text-center-l operation-cell"
              v-if="row.isAuthorized">
              <el-button
                type="text"
                size="small"
                class="noborder-btn"
                v-if="isButttonVisible(row, 'rename')"
                @click="reName(row)"
                >重命名</el-button
              >
              <el-button
                type="text"
                size="small"
                class="noborder-btn"
                v-if="isButttonVisible(row, 'moveTo')"
                @click="moveTo(row)"
                >移动到</el-button
              >
              <!--此处按钮假按钮,仅在视觉上展示,用v-if来控制显隐-->
              <el-button
                v-if="isButttonVisible(row, 'upload') && isConverting(row)"
                type="text"
                size="small"
                class="upload-text-btn noborder-btn current-upload-btn"
                :disabled="true"
                >上传</el-button
              >
              <!--此处按钮为Webuploader上传按钮,用v-show来控制显隐-->
              <el-button
                v-show="isButttonVisible(row, 'upload') && !isConverting(row)"
                type="text"
                key="uploadFile"
                size="small"
                class="upload-text-btn noborder-btn current-upload-btn"
                :id="`upload-${row.nodeId}`"
                @click="upload(row)"
                >上传</el-button
              >
              <el-button
                v-if="isButttonVisible(row, 'files')"
                type="text"
                size="small"
                class="noborder-btn"
                @click="openFileTableDialog(row)"
                :disabled="row.status === 1 || row.status === 2"
                >子文件</el-button
              >
              <el-button
                v-if="isButttonVisible(row, 'submitConvert')"
                type="text"
                size="small"
                class="noborder-btn"
                :disabled="row.status === 1 || row.status === 2"
                @click="submitConvertFiles([row])"
                >转换</el-button
              >
              <el-button
                v-if="isButttonVisible(row, 'deleteNode')"
                type="text"
                size="small"
                class="noborder-btn"
                @click="deleteNodes([row])"
                :disabled="row.status === 1 || row.status === 2"
                >删除</el-button
              >
              <div
                class="common-dropdown-box"
                v-if="isBatchButttonVisible(row, 'modelGroupButtons')">
                <el-dropdown
                  placement="bottom"
                  @command="commond => modelGroupBatchOperate(commond, [row])"
                  :disabled="row.status === 1 || row.status === 2">
                  <el-button
                    type="text"
                    size="small"
                    :disabled="row.status === 1 || row.status === 2">
                    更多
                  </el-button>
                  <el-dropdown-menu
                    slot="dropdown"
                    class="common-dropdown-menu dropdown-dark dropdown-primary dropdown--table-primary">
                    <el-dropdown-item
                      v-if="
                        isButttonVisible(
                          row,
                          'setCoordinate',
                          'modelGroupButtons'
                        )
                      "
                      command="1"
                      >设置坐标系</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="
                        isButttonVisible(row, 'rename', 'modelGroupButtons')
                      "
                      command="2"
                      >重命名</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="
                        isButttonVisible(row, 'moveTo', 'modelGroupButtons')
                      "
                      command="3"
                      >移动到</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="
                        isButttonVisible(row, 'deleteNode', 'modelGroupButtons')
                      "
                      command="5"
                      >删除</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="
                        isButttonVisible(
                          row,
                          'versionManage',
                          'modelGroupButtons'
                        ) && row.successVersion > 1
                      "
                      command="6"
                      >版本管理</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="
                        isButttonVisible(row, 'share', 'modelGroupButtons') &&
                        row.successVersion > 0
                      "
                      command="7"
                      >分享</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="150"
          v-if="isOperateVisible() && isDemoProject()">
          <template v-slot="{ row }">
            <div class="common-button-box">
              <el-button
                v-if="isButttonVisible(row, 'files')"
                type="text"
                size="small"
                @click="openFileTableDialog(row)"
                :disabled="row.status === 1 || row.status === 2"
                >子文件</el-button
              >
              <el-button
                v-if="isChecked('Project.Single.Metadata.Bim.HisList')"
                type="text"
                size="small"
                :disabled="!(row.successVersion > 1)"
                @click="viewVersion(row)">
                版本管理
              </el-button>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="common-empty-box">
            <bj-empty class="empty-page">
              <template>
                <div class="empty-text">抱歉，没有找到相关内容</div>
              </template>
            </bj-empty>
          </div>
        </template>
      </el-table>
    </div>
    <div class="common-pagination-box pagination-primary">
      <el-pagination
        popper-class="common-pagination-popper-box"
        layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 150, 200]"
        :page-size="size"
        :current-page="page"
        :total="total"
        @size-change="sizeChange"
        @current-change="pageChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  formatFileSize,
  formatTime,
  formatSecond
} from '@/utils/generalMethods'

import { Store } from '@/utils/store'
import {
  getBimNodeList,
  deleteBimDataSetCheckService,
  deleteBimFolderNode,
  deleteBimDataSetNode,
  getBimDatasetFiles,
  getProjectStatus,
  batchGetProjectStatusService,
  getProjectsConvertingProgress,
  getHistoryVersion,
  isUpgradeService,
  getTextureList
} from '@/service/interface'
const ButtonsList = [
  {
    name: 'rename',
    nodeType: [1],
    permissionCode: 'Project.Single.DataSet.BimTree.RenameNode'
  },
  {
    name: 'moveTo',
    nodeType: [1],
    permissionCode: 'Project.Single.DataSet.BimTree.MoveNode'
  },
  {
    name: 'files',
    nodeType: [2],
    permissionCode: 'Project.Single.Metadata.Bim.List'
  },
  {
    name: 'deleteNode',
    nodeType: [1],
    permissionCode: 'Project.Single.DataSet.BimTree.DeleteNode'
  },
  {
    name: 'upload',
    nodeType: [2],
    permissionCode: 'Project.Single.Metadata.Bim.Upload'
  },
  {
    name: 'submitConvert',
    nodeType: [2],
    permissionCode: 'Project.Single.Metadata.Bim.Convert'
  },
  {
    name: 'modelGroupButtons',
    nodeType: [2],
    children: [
      {
        name: 'setCoordinate',
        nodeType: [2],
        permissionCode: 'Project.Single.DataSet.BimTree.RenameNode'
      },
      {
        name: 'rename',
        nodeType: [2],
        permissionCode: 'Project.Single.DataSet.BimTree.RenameNode'
      },
      {
        name: 'moveTo',
        permissionCode: 'Project.Single.DataSet.BimTree.MoveNode'
      },
      {
        name: 'deleteNode',
        nodeType: [2],
        permissionCode: 'Project.Single.DataSet.BimTree.DeleteNode'
      },
      {
        name: 'versionManage',
        nodeType: [2],
        permissionCode: 'Project.Single.Metadata.Bim.HisList'
      },
      {
        name: 'share',
        nodeType: [2],
        permissionCode: 'Project.Single.DataSet.Bim.Share'
      }
    ]
  }
]
const FileTypesConfig = ['rvt', '3dxml', '3dm', 'skp']
export default {
  data() {
    return {
      dataList: [],
      // 用于处理转换服务停止之后再重启的情况
      convertingDataSets: [],
      selectDatasets: [],
      page: 1,
      size: 10,
      customHeaders: '',
      total: 0
    }
  },
  props: {
    rootNodeId: String,
    nodeId: String,
    name: String,
    customUploader: Object,
    updateModelGroupTableVisible: Function,
    refreshCatalogTree: Function,
    handleCellClick: Function,
    reNameNode: Function,
    submitConvert: Function,
    openConfigDialog: Function,
    openVersionDialog: Function,
    openMoveTreeDialog: Function,
    openCoordinateDialog: Function,
    openShareDialog: Function,
    openFileTableDialog: Function,
    updateModelGroupInfo: Function
  },
  mounted() {
    const currentBody = this.$refs.modelGroupTable?.bodyWrapper
    const _this = this
    currentBody &&
      currentBody.addEventListener('scroll', ev => {
        const scrollTop = ev.target.scrollTop
        _this.customHeaders = scrollTop > 10 ? 'darkHeader' : ''
      })
    this.$eventManage.on('handleFileException', this.onHandleFileException)
  },
  beforeDestroy() {
    this.clearProgressTimer()

    this.$eventManage.off('handleFileException', this.onHandleFileException)
  },
  methods: {
    pageChange(page) {
      this.page = page
      this.uploadDataList()
    },
    sizeChange(size) {
      this.size = size
      this.page = 1
      this.uploadDataList()
    },
    uploadDataList(page) {
      return new Promise(resolve => {
        if (page) {
          this.page = page
        }
        let params = {
          skipCount: (this.page - 1) * this.size,
          resultCount: this.size,
          nodeId: this.nodeId,
          nodeName: this.name
        }
        getBimNodeList(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataList = data.items
            dataList.forEach(item => {
              let find = this.dataList.find(
                el => el.dataSetId === item.dataSetId
              )
              if (find && find.rate) {
                item.rate = find.rate
                item.rateMsg = find.rateMsg
              }
            })
            this.dataList = dataList
            this.total = data.totalCount
            this.selectDatasets = []

            this.progressTimer && clearInterval(this.progressTimer)
            let dataSets = dataList.filter(el => el.nodeType === 2)
            // prettier-ignore
            dataSets = dataSets.filter(el=> el.status === 1 || el.status === 2);
            if (dataSets.length) {
              let dataSetIds = dataSets.map(el => el.dataSetId)
              // 防止nodeList接口返回的数据集状态不正确，导致出现死循环一直请求数据。通过转换状态接口进一步确认数据集的状态
              this.batchGetProjectStatus(dataSetIds).then(dataSetList => {
                const convertingStatus = [1, 2, 30, 60]
                // prettier-ignore
                dataSetList = dataSetList.filter((el) => convertingStatus.includes(el.status));
                let convertingDataSets = []
                dataSets.forEach(item => {
                  let find = dataSetList.find(
                    el => el.dataSetId === item.dataSetId
                  )
                  if (find) {
                    convertingDataSets.push(item)
                  }
                })
                if (convertingDataSets.length) {
                  this.updateConvertProgress(convertingDataSets)
                  // prettier-ignore
                  this.progressTimer = setInterval(this.updateConvertProgress, 10000, convertingDataSets);
                }
              })
            }

            this.$nextTick(() => {
              this.refreshDom()
            })

            resolve(data.totalCount)
          } else {
            resolve(0)
          }
        })
      })
    },
    batchGetProjectStatus(dataSetIds) {
      return new Promise(resolve => {
        let params = { dataSetIds }
        batchGetProjectStatusService(params).then(response => {
          if (response.isSuccess) {
            let dataList = response.data
            resolve(dataList)
          } else {
            this.$message(response.errMsg)
          }
        })
      })
    },
    reName(nodeInfo) {
      this.reNameNode(nodeInfo)
    },
    moveTo(nodeInfo) {
      this.openMoveTreeDialog([nodeInfo])
    },
    upload(nodeInfo) {
      let projName = this.$route.params.projName
      let levelPathName = nodeInfo.levelPathName
      this.customUploader.setCurrNodeType(nodeInfo.nodeType)
      this.customUploader.setCurrDataSetId(nodeInfo.nodeId)
      this.customUploader.setUploadPathName(`${projName}/${levelPathName}`)
      this.customUploader.setStatus('waiting')
    },
    modelView(dataInfo) {
      if (dataInfo.nodeType === 2) {
        if (dataInfo.status === 5 || dataInfo.successVersion > 0) {
          let projId = dataInfo.projId
          let projName = this.$route.params.projName
          projName = encodeURIComponent(projName)
          let url = `/singleProject/datasetView/${projId}/${projName}?datasetId=${dataInfo.nodeId}&dataType=${this.schemeType}`
          let { theme, isHeaderHidden } = this.$route.query
          if (theme) {
            url += `&theme=${theme}`
          }
          if (isHeaderHidden) {
            url += `&isHeaderHidden=false`
          }
          sessionStorage.setItem('isAuthorized', dataInfo.isAuthorized)
          this.$router.push(url)

          let nodeId = dataInfo.parentId
          sessionStorage.setItem('BimNodeId', nodeId)
        } else {
          this.$message.warning('文件尚未转换，请转换成功后再查看')
        }
      }
    },
    isNeedUpgrade(dataSets) {
      return new Promise(resolve => {
        let dataSetIds = dataSets.map(el => el.nodeId)
        isUpgradeService({ dataSetIds }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            // 是否需要提示
            let flag = data.some(el => el.needUpgrade && el.versionNum > 1)
            if (flag) {
              let message =
                '为保证更好的用户体验，系统进行了重大升级。本次转换将会合并当前模型的全部历史版本，是否继续？'
              this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  resolve(true)
                })
                .catch(() => {
                  this.$message.info('取消转换')
                  resolve(false)
                })
            } else {
              resolve(true)
            }
          } else {
            this.$message.error(response.errMsg)
            resolve(false)
          }
        })
      })
    },
    submitConvertFiles(dataSets) {
      let startInterval = setInterval(() => {
        this.disabled = false
        clearInterval(startInterval)
      }, 60000)

      if (!this.disabled) {
        let dataSetInfo = dataSets[0]
        let dataSetId = dataSetInfo.nodeId
        this.isNeedUpgrade(dataSets).then(result => {
          if (result) {
            getTextureList({ dataSetId }).then(response => {
              if (response.isSuccess) {
                let data = response.data
                let appliedData = data.filter(el => el.isApplied)
                if (appliedData.length) {
                  // prettier-ignore
                  let message = "检测到模型包含已应用的纹理信息，提交转换后需要重新应用方可查看，确定继续转换?";
                  this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  })
                    .then(() => {
                      if (window.isLinux) {
                        this.submitConvert(dataSets)
                        this.disabled = false
                        return
                      }

                      let params = {
                        dataSetId,
                        resultCount: 1000,
                        skipCount: 0,
                        status: [4]
                      }
                      getBimDatasetFiles(params).then(res => {
                        if (res.isSuccess) {
                          let data = res.data
                          let files = data.items

                          let configFiles = files.filter(item => {
                            let fileType = item.fileName.substring(
                              item.fileName.lastIndexOf('.') + 1
                            )
                            return FileTypesConfig.includes(fileType)
                          })
                          if (configFiles.length) {
                            // prettier-ignore
                            if (this.isChecked("Project.Single.Metadata.Bim.CofigConvert")) {
                          // prettier-ignore
                          let fileConfigInfo = this.getFileConfigInfo(configFiles, dataSetInfo);
                          this.openConfigDialog(dataSets, fileConfigInfo);
                          } else {
                            this.$message.warning("存在当前环境不支持转换的文件类型，请重新选择");
                          }
                          } else {
                            this.submitConvert(dataSets)
                          }
                        } else {
                          this.$message.error(res.errMsg)
                        }
                      })
                    })
                    .catch(() => {
                      this.$message.info('取消转换')
                    })
                } else {
                  if (window.isLinux) {
                    this.submitConvert(dataSets)
                    this.disabled = false
                    return
                  }

                  let params = {
                    dataSetId,
                    resultCount: 1000,
                    skipCount: 0,
                    status: [4]
                  }
                  getBimDatasetFiles(params).then(res => {
                    if (res.isSuccess) {
                      let data = res.data
                      let files = data.items

                      let configFiles = files.filter(item => {
                        let fileType = item.fileName.substring(
                          item.fileName.lastIndexOf('.') + 1
                        )
                        return FileTypesConfig.includes(fileType)
                      })
                      if (configFiles.length) {
                        // prettier-ignore
                        let fileConfigInfo = this.getFileConfigInfo(configFiles, dataSetInfo);
                        this.openConfigDialog(dataSets, fileConfigInfo)
                      } else {
                        this.submitConvert(dataSets)
                      }
                    } else {
                      this.$message.error(res.errMsg)
                    }
                  })
                }
              }
            })
          }

          this.disabled = false
        })

        this.disabled = true
      }
    },
    getFileConfigInfo(configFiles, dataSetInfo) {
      let fileConfigInfo = {
        isModelManage: false,
        // 链接模型组不校验三维视图是否存在
        isLinkModel: dataSetInfo.isLinkModel,
        isBatchConfig: configFiles.length > 1 ? true : false,
        // 文件转换配置弹窗是否展示'保留单文件配置'选项
        isCoveredVisible: false,
        // 文件转换配置是是否获取项目转换配置
        // 如果是模型管理且需要配置的文件数量超过两个，需要获取项目配置，根据用户是否选择'保留单文件配置'的结果
        // 决定是否保留用户的单文件配置
        isGetProjConfig: true
      }

      configFiles.forEach(item => {
        let fileType = ''
        if (item.fileType) {
          fileType = item.fileType.substring(item.fileType.lastIndexOf('.') + 1)
        } else {
          fileType = item.fileName.substring(item.fileName.lastIndexOf('.') + 1)
        }
        if (fileConfigInfo[fileType]) {
          fileConfigInfo[fileType].push(item)
        } else {
          fileConfigInfo[fileType] = [item]
        }
      })

      return fileConfigInfo
    },
    batchSetCoordinate() {
      let datas = this.selectDatasets
      datas = datas.filter(el => el.nodeType === 2)
      if (!datas.length) {
        this.$message.warning('请勾选需要设置坐标系模型组')
        return
      }

      let datsSetIds = datas.map(el => el.nodeId)
      this.openCoordinateDialog(datsSetIds)
    },

    batchShare() {
      let datas = this.selectDatasets
      datas = datas.filter(el => el.nodeType === 2)
      if (!datas.length) {
        this.$message.warning('请勾选需要分享的文件')
        return
      }
      let invalidDataSets = []
      if (this.schemeType === 'Bim') {
        invalidDataSets = datas.filter(el => el.successVersion < 1)
      } else {
        invalidDataSets = datas.filter(el => el.status !== 5)
      }
      if (invalidDataSets.length) {
        let dataSetNameList = invalidDataSets.map(el => el.nodeName)
        let warningMsg = this.getWarningMessage(
          dataSetNameList,
          '尚未转换成功，不能被分享'
        )
        this.$message.warning(warningMsg)
      }
      if (this.schemeType === 'Bim') {
        datas = datas.filter(el => el.successVersion > 0)
      } else {
        datas = datas.filter(el => el.status === 5)
      }

      this.openShareDialog(datas)
    },
    batchMoveNode() {
      let datas = this.selectDatasets
      let invalidDatas = datas.filter(el => el.status === 1 || el.status === 2)
      if (invalidDatas.length) {
        this.$message.warning('有文件正在转换中，请稍后再试')
        return
      }
      if (datas.length) {
        this.openMoveTreeDialog(datas)
      } else {
        this.$message.warning('请先勾选文件')
      }
    },
    batchDeleteNode() {
      let datas = this.selectDatasets
      let invalidDatas = datas.filter(el => el.status === 1 || el.status === 2)
      if (invalidDatas.length) {
        this.$message.warning('有文件正在转换中，请稍后再试')
        return
      }
      if (datas.length) {
        this.deleteNodes(datas)
      } else {
        this.$message.warning('请先勾选文件')
      }
    },
    deleteNodes(datas) {
      this.datasTodelete = datas
      this.deleteBimNodes(datas)
    },
    deleteDatasets() {
      let datas = this.datasTodelete
      let folderNodes = datas.filter(el => el.nodeType === 1)
      let folderNodeIds = folderNodes.map(el => el.nodeId)
      let dataSetNodes = datas.filter(el => el.nodeType === 2)
      let dataSetNodeIds = dataSetNodes.map(el => el.nodeId)

      if (folderNodeIds.length) {
        deleteBimFolderNode({ nodeIds: folderNodeIds }).then(response => {
          if (response.isSuccess) {
            if (dataSetNodeIds.length) {
              deleteBimDataSetNode({ dataSetIds: dataSetNodeIds }).then(res => {
                if (res.isSuccess) {
                  this.page = 1
                  this.uploadDataList().then(total => {
                    this.datasTodelete = []
                    this.refreshCatalogTree()
                    this.updateModelGroupTableVisible(total)
                    this.$message.success('删除成功!')
                  })
                }
              })
            } else {
              this.page = 1
              this.uploadDataList().then(total => {
                this.datasTodelete = []
                this.refreshCatalogTree()
                this.updateModelGroupTableVisible(total)
                this.$message.success('删除成功!')
              })
            }
          }
        })
      } else {
        deleteBimDataSetNode({ dataSetIds: dataSetNodeIds }).then(res => {
          if (res.isSuccess) {
            this.page = 1
            this.uploadDataList().then(total => {
              this.refreshCatalogTree()
              this.updateModelGroupTableVisible(total)
              this.$message.success('删除成功!')
            })
          }
        })
      }
    },
    onHandleFileException(events) {
      let eventInfo = events.eventInfo
      let { order, eventSource } = eventInfo
      if (eventSource !== 'modelGroupTable') return
      if (order === 'cancel') {
        this.datasTodelete = []
        // this.$message.info('取消删除')
      } else {
        this.deleteDatasets()
      }
    },
    deleteBimNodes(datas) {
      let dataSetNodes = datas.filter(el => el.nodeType === 2)
      let dataSetIds = dataSetNodes.map(el => el.nodeId)

      if (dataSetNodes.length) {
        deleteBimDataSetCheckService({ dataSetIds }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataSets = data.dataSets
            if (dataSets.length) {
              let obj = {
                eventSource: 'modelGroupTable',
                errType: 'sceneQuoteException',
                errMsg: data.message,
                quoteData: dataSets,
                count: dataSets.length
              }
              this.$eventManage.fire('fileException', { eventInfo: obj })
            } else {
              let obj = {
                eventSource: 'modelGroupTable',
                errType: 'deleteTip',
                errMsg: data.message
              }
              this.$eventManage.fire('fileException', { eventInfo: obj })
            }
          }
        })
      } else {
        let obj = {
          eventSource: 'modelGroupTable',
          errType: 'deleteTip',
          errMsg: '已选数据删除后不可恢复，是否继续'
        }
        this.$eventManage.fire('fileException', { eventInfo: obj })
      }
    },
    setCoordinate(dataInfo) {
      let dataSetIds = [dataInfo.nodeId]
      this.openCoordinateDialog(dataSetIds, dataInfo)
    },
    viewVersion(dataInfo) {
      if (dataInfo.successVersion < 2) return
      let nodeId = dataInfo.nodeId
      getHistoryVersion(nodeId).then(response => {
        if (response.isSuccess) {
          let versionList = response.data
          let versionInfo = {
            dataSetId: dataInfo.dataSetId,
            dataSetName: dataInfo.dataSetName,
            successVersion: dataInfo.successVersion,
            versionList
          }
          this.openVersionDialog(versionInfo)
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    folderBatchOperate(command, datas) {
      switch (command) {
        case '1':
          this.openMoveTreeDialog(datas)
          break
        case '2':
          console.log('复制到')
          break
        default:
          break
      }
    },
    modelGroupBatchOperate(command, datas) {
      switch (command) {
        case '1': {
          let dataInfo = datas[0]
          this.setCoordinate(dataInfo)
          break
        }
        case '2': {
          let nodeInfo = datas[0]
          this.reNameNode(nodeInfo)
          break
        }
        case '3':
          this.openMoveTreeDialog(datas)
          break
        case '4':
          console.log('复制')
          break
        case '5':
          this.deleteNodes(datas)
          break
        case '6': {
          let dataInfo = datas[0]
          this.viewVersion(dataInfo)
          break
        }
        case '7': {
          let dataInfo = datas[0]
          if (dataInfo.successVersion < 1) {
            let warningMsg = `${dataInfo.nodeName}尚未转换成功，不能被分享`
            this.$message.warning(warningMsg)
            return
          }
          this.openShareDialog([dataInfo])
          break
        }
        default:
          break
      }
    },
    handleClick(dataInfo, column) {
      if (column.label === '操作' || column.type === 'selection') return

      // if (!column.label.includes('名称')) {
      //   this.$refs.modelGroupTable.toggleRowSelection(dataInfo)
      //   return
      // }

      if (dataInfo.nodeType === 1) {
        this.handleCellClick(dataInfo)
        return
      }
    },
    updateModelGroupDataInfo(dataInfo) {
      let find = this.dataList.find(el => el.nodeId === dataInfo.dataSetId)
      if (find) {
        this.updateModelGroupInfo(find)
      }
    },
    indexMethod(index) {
      return index + 1 + (this.page - 1) * this.size
    },
    selectChange(selection) {
      this.selectDatasets = selection
    },
    selectAll(selection) {
      this.selectDatasets = selection
    },
    updateConvertProgress(convertingModels) {
      let dataSetIds = convertingModels.map(el => el.nodeId)
      getProjectsConvertingProgress({ dataSetIds }).then(response => {
        if (response.isSuccess) {
          let dataList = response.data
          for (let i = 0; i < dataList.length; i++) {
            let item = dataList[i]
            if (item.ratio === -1) {
              this.uploadDataList().then(() => {
                this.updateModelGroupDataInfo(item)
              })
              break
            }

            let ratio = Math.round(item.ratio / 100) / 100
            let find = this.dataList.find(el => el.nodeId === item.dataSetId)

            // 用于处理转换服务停止之后再重启的情况
            let findDataset = this.convertingDataSets.find(
              el => el.dataSetId === item.dataSetId
            )
            if (findDataset && findDataset.isMarked && ratio === 0) {
              this.convertingDataSets = []
              this.uploadDataList().then(() => {
                this.updateModelGroupDataInfo(item)
              })
              break
            }

            if (ratio > 0 && find.status === 1) {
              this.uploadDataList().then(() => {
                this.updateModelGroupDataInfo(item)
              })
              break
            }

            if (ratio === 100) {
              getProjectStatus({ dataSetId: item.dataSetId }).then(res => {
                if (res.isSuccess) {
                  let result = res.data
                  let status = result.status
                  if (status === 10 || status === 20) {
                    this.uploadDataList().then(() => {
                      this.updateModelGroupDataInfo(item)
                    })
                    this.refreshCatalogTree()
                  } else {
                    this.$set(find, 'rate', 99)
                    // find.rate = 99;
                  }
                }
              })
              break
            } else {
              this.$set(find, 'rate', ratio)
              this.$set(find, 'rateMsg', item.message)
              // 用于处理转换服务停止之后再重启的情况
              if (ratio > 0) {
                if (!findDataset) {
                  this.convertingDataSets.push({
                    dataSetId: item.dataSetId,
                    isMarked: true
                  })
                }
              }
              // find.rate = ratio;
            }
          }
        }
      })
    },
    isButttonVisible(dataInfo, buttonName, fatherButtonName) {
      let visible = false
      if (!fatherButtonName) {
        let find = ButtonsList.find(el => el.name === buttonName)
        visible =
          find.nodeType.includes(dataInfo.nodeType) &&
          this.isChecked(find.permissionCode)
      } else {
        let batchButton = ButtonsList.find(el => el.name === fatherButtonName)
        let childrens = batchButton.children
        let find = childrens.find(el => el.name === buttonName)
        visible = this.isChecked(find.permissionCode)
      }
      return visible
    },
    isConverting(dataInfo) {
      return dataInfo.status === 1 || dataInfo.status === 2
    },
    isBatchButttonVisible(dataInfo, buttonName) {
      let visible = false
      let find = ButtonsList.find(el => el.name === buttonName)
      if (find.nodeType.includes(dataInfo.nodeType)) {
        let childrens = find.children

        visible = childrens.some(el => {
          if (el.name === 'versionManage') {
            return (
              this.isChecked(el.permissionCode) && dataInfo.successVersion > 1
            )
          } else {
            return this.isChecked(el.permissionCode)
          }
        })
      }

      return visible
    },
    clearProgressTimer() {
      this.progressTimer && clearInterval(this.progressTimer)
      this.progressTimer = null
    },
    refreshDom() {
      let dataList = this.dataList

      dataList.forEach(item => {
        let uploadDom = document.getElementById(`upload-${item.nodeId}`)
        if (uploadDom) {
          let child = uploadDom.children[0]
          if (!child.className.includes('webuploader-pick')) {
            this.customUploader.uploader.addButton({
              id: `#upload-${item.nodeId}`
            })
          }
        }
      })
    },
    isDisable(dataInfo) {
      let isDisable = false
      if (dataInfo.nodeType === 2) {
        isDisable = !(dataInfo.status === 5 || dataInfo.successVersion > 0)
      }
      return isDisable
    },
    getIcon(dataInfo) {
      let icon = ''
      let title = ''
      let className = ''
      if (dataInfo.nodeType === 1) {
        if (dataInfo.isAuthorized) {
          icon = 'ic-ico_folder'
        } else {
          icon = 'ic-a-wenjianzhidu1'
        }
        className = 'icon'
      } else {
        if (dataInfo.hasNewFile && dataInfo.successVersion > 0) {
          icon = 'ic-jiancegengxin'
          className = 'icon-update'
          title = '当前文件有更新,提交转换后可查看最新版本'
        }
        // prettier-ignore
        if (!(dataInfo.hasNewFile && dataInfo.successVersion > 0) && dataInfo.isLinkModel) {
          icon = "icon-lianjie1";
          className = "icon-link";
          title = "链接模型";
        }
      }
      return { icon, title, className }
    },
    getWarningMessage(dataSetNameList, messageTail) {
      let message = ''
      let messageHead = ''
      // 超过两个文件只展示前两个
      if (dataSetNameList.length > 2) {
        messageHead = `${dataSetNameList[0]}、${dataSetNameList[1]}等${dataSetNameList.length}个`
      } else {
        messageHead = dataSetNameList.join('、')
      }
      message = `${messageHead}${messageTail}`
      return message
    },
    getCoordinate(dataSetInfo) {
      let coordinate = '--'
      if (dataSetInfo.coordinatesConfig) {
        let coordinatesConfig = JSON.parse(dataSetInfo.coordinatesConfig)

        let coordinatesType = coordinatesConfig.CoordinatesType
        if (coordinatesType === 'CalibrationPoint') {
          let point = coordinatesConfig.CoordinatesPoint
          let { Latitude, Longitude } = point
          coordinate = `ENU:${Latitude},${Longitude}`
        } else {
          coordinate = coordinatesConfig.Coordinates
        }
      }

      return coordinate
    },
    isOperateVisible() {
      let visible = false
      visible = ButtonsList.some(item => {
        if (item.permissionCode) {
          return this.isChecked(item.permissionCode)
        } else {
          let childrens = item.children
          return childrens.some(el => this.isChecked(el.permissionCode))
        }
      })

      return visible
    },
    isDemoProject() {
      let isDemoProj = JSON.parse(sessionStorage.getItem('isDemoProj'))
      return isDemoProj
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatFileSize,
    formatTime,
    formatSecond
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.model-group-table-box {
  height: 100%;
  .pagination-primary {
    // background-color: var(--aside-bg-color);
  }
  .operation-cell {
    column-gap: 18px;
    justify-content: flex-start;
    :deep(.el-button) {
      flex-shrink: 0;
      width: 35px;
      margin-left: 0;
      &:hover {
        line-height: normal;
      }
    }

    .common-dropdown-box {
      width: 35px;

      :deep(.el-dropdown) {
        margin-left: 0;
      }
    }

    .upload-text-btn {
      margin-bottom: 2px;
    }

    .current-upload-btn {
      height: 23px !important;
      :deep(.webuploader-pick) {
        height: 24px;
        line-height: 26px;
      }
    }
  }

  .common-table-box {
    height: calc(100% - 64px) !important;

    :deep(.el-table__body-wrapper) {
      height: calc(100% - 68px);
    }

    .publish-table {
      :deep(.el-table__header) {
        .el-table__cell {
          &:nth-child(3) {
            .cell {
              padding-left: 36px;
            }
          }
        }
      }
      .el-table__body {
        .operation-cell {
          .el-button {
            height: auto;
            line-height: normal;
          }

          .webuploader-container {
            height: 22px;
          }
        }
      }
    }
  }

  .icon-column {
    display: flex;
    color: var(--modelgroup-table-text-color);
    &-center {
      display: flex;
      align-items: center;
      min-width: 26px;

      .icon-link {
        margin-right: 8px;
      }
    }
    .content-box {
      .name {
        cursor: pointer;
        &:hover {
          color: var(--base-primary-bgColor);
          text-decoration: underline;
        }
      }

      .details {
        font-size: 12px;

        .file-type {
          margin-left: 10px;
        }
      }
    }

    .icon-update {
      margin-right: 10px;
      font-size: 16px;
      color: #1afa29;
    }

    .icon-link {
      font-size: 16px;
      color: var(--primary-color);
    }
  }

  .common-progress-box {
    .progress-name-box {
      .msg-box {
        max-width: 96px;
        margin: auto;
      }
    }
  }

  .disabled {
    color: var(--disabled-text-color);
    &:hover {
      .content-box {
        .name {
          color: var(--disabled-text-color);
          text-decoration: unset;
          cursor: not-allowed;
        }
      }
    }
  }

  .version-icon {
    margin-left: 5px;
    font-size: 15px;
    vertical-align: bottom;
  }

  .common-button-box {
    display: flex;

    // .el-button {
    //   width: 40px;
    // }

    .upload-text-btn {
      margin-left: -10px;
      width: 50px;
    }
  }

  .common-pagination-box {
    margin-top: 0px;
  }

  .status-text {
    display: flex;
    .circle {
      width: 5px;
      height: 5px;
      margin: auto 10px auto 0px;
      border-radius: 50%;
    }

    .bg-color1 {
      background: var(--normal-status-color);
    }

    .bg-color2 {
      background: var(--runing-status-color);
    }

    .bg-color3 {
      background: var(--error-status-color);
    }

    .bg-color4 {
      background: var(--success-status-color);
    }

    .color1 {
      color: var(--normal-status-color);
    }

    .color2 {
      color: var(--runing-status-color);
    }

    .color3 {
      color: var(--error-status-color);
    }
    .color4 {
      color: var(--success-status-color);
    }
  }
}
</style>
